import type {
  _Date,
  AgreementData,
  PriceIndexing,
} from "$apis/parkito2/types.gen.ts";
import { IntervalModel } from "$models";

export default class AgreementDataModel implements AgreementData {
  constructor(private _data: AgreementData) {
  }

  get data(): AgreementData {
    return this._data;
  }
  get debtorId(): string {
    return this.data.debtorId;
  }
  get endDate(): _Date | undefined {
    return this.data.endDate ?? undefined;
  }
  get invoiceFrom(): _Date {
    return this.data.invoiceFrom;
  }
  get isResidental(): boolean {
    return this.data.isResidental;
  }
  get noticePeriod() {
    return this.data.noticePeriod;
  }
  get offerNoticePeriod() {
    return new IntervalModel(this.data.offerNoticePeriod);
  }
  get period() {
    return this.data.period ?? undefined;
  }
  get priceIndexing(): PriceIndexing | undefined {
    return this.data.priceIndexing ?? undefined;
  }
  get siteId(): string {
    return this.data.siteId;
  }
  get startDate(): _Date | undefined {
    return this.data.startDate ?? undefined;
  }
  get supersedesId(): string | undefined {
    return this.data.supersedesId ?? undefined;
  }
}
